import * as React from 'react';

import CircleX16 from './CircleX16';

export const circleX16 = () => <CircleX16 />;

export default {
    title: 'Icon/Line/CircleX16',
    component: CircleX16,
    parameters: {
        notes: "`import CircleX16 from 'box-ui-elements/es/icon/line/CircleX16';`",
    },
};
